import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

// eslint-disable-next-line  @angular-eslint/directive-selector
@Directive({ selector: 'form, textarea, input, select' })
export class DisableAutoCompleteDirective implements OnInit {
  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit() {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'autocomplete', 'off');
  }
}
